export enum NotificationTypeEnum {
  FileSync = 'file-sync',
  ConnectionError = 'connection-error',
  OrderReceived = 'order-received',
  NewTeammate = 'new-teammate',
}
